<app-page-panel 
[showBackButton]="true" 
iconNameFontAwesome="wallet" 
[pageTitle]="'Budgetantrag Details' + (budgetService.antrag()!.freigabeFinal ? ' (Archiv)' : '')"
[showCheckedButton]="budgetService.allowEdit()" [showHistoryButton]="true" [showDeleteButton]="budgetService.allowEdit()" [showDetailsButton]="false"
[showBackColor]="false" (backButtonClicked)="BackButtonClick()" (checkedButtonClicked)="budgetService.onCheckedButtonClick()"
(deleteButtonClicked)="DeleteButtonClick()"
[iconMenuButtons]="navigationService.iconMenuItems"
[iconMenuOffset]="'..'"
>

<div class="flex flex-fill flex-gap-120 flex-row flex-stretch-self">
        <app-element-panel pageTitle="Details">
            <div class="flex flex-col flex-fill flex-stretch-self ">
                <div class="flex flex-row flex-fit" [ngClass]="budgetService.isBauControlling() ? 'flex-gap-48' : 'flex-gap-120'">
                    <mat-form-field class="flex-fill">
                        <mat-label>WIP {{budgetService.antrag().wipName}}</mat-label>
                        <mat-select [disabled]="!budgetService.allowEdit()" required [(ngModel)]="budgetService.antrag().wip"
                            name="wirtschaftsplaene" (selectionChange)="budgetService.onWipValueChanged($event)" cdkFocusInitial>
                            <mat-option *ngFor="let wirtschaftsplan of budgetService.wirtschaftsplaene()"
                                [value]="wirtschaftsplan.id">{{wirtschaftsplan.wip}}</mat-option>
                        </mat-select> </mat-form-field>
                    <mat-form-field class="flex-fill">
                        <mat-label>Nr</mat-label>
                        <input [readonly]="!budgetService.allowEdit()" matInput type="number" required placeholder="Nr"
                            [(ngModel)]="budgetService.antrag().nr"
                            (ngModelChange)="budgetService.DataStateChange()" name="nr">
                    </mat-form-field>
                </div>
                <mat-form-field class="flex flex-fill">
                    <mat-label>Projektbeschreibung</mat-label>
                    <textarea matInput [readonly]="!budgetService.allowEdit()" class="textarea-fit" required
                        placeholder="Beschreibung" [(ngModel)]="budgetService.antrag().beschreibung"
                        (ngModelChange)="budgetService.BeschreibungChange($event);" maxlength="1500"
                        name="beschreibung"></textarea>
                    <button  [disabled]="!budgetService.allowEdit()" type="button" [ngClass]="{'color-warn': !budgetService.antrag().beschreibungValidated}" matSuffix matTooltip="Bestätigen"
                        mat-icon-button class="mat-icon-button-move-left" (click)="budgetService.BeschreibungButtonClick()">
                        <mat-icon>{{budgetService.antrag().beschreibungValidated ? 'check_circle' : 'error'}}</mat-icon>
                    </button>
                </mat-form-field>
            </div>
            <div class="flex flex-row flex-stretch-self flex-justify" [ngClass]="budgetService.isBauControlling() ? 'flex-gap-48' : 'flex-gap-120'">
                <div class="flex flex-row flex-fill-force flex-gap-12">
                    <mat-form-field class="flex-fill form-field-readonly width-50">
                        <mat-label>Projektanfang</mat-label>
                        <input matInput [matDatepicker]="pickerProjektanfang" [readonly]="true" 
                               placeholder="Projektanfang" [(ngModel)]="budgetService.antrag().anfang" name="projektanfang">
                        <mat-datepicker #pickerProjektanfang></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field class="flex-fill width-50">
                        <mat-label>Projektende</mat-label>
                        <input matInput required [matDatepicker]="pickerProjektende"  placeholder="TT.MM.JJJJ"  [readonly]="!budgetService.allowEdit()"
                            placeholder="Projektende" [(ngModel)]="budgetService.antrag().ende" (ngModelChange)="budgetService.antrag().endeChanged = true; budgetService.DataStateChange();" name="projektende" 
                            [afterDate]="budgetService.antrag().anfang">
                        <mat-datepicker-toggle matIconSuffix [for]="pickerProjektende"></mat-datepicker-toggle>                           
                        <mat-datepicker #pickerProjektende></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="flex flex-row flex-fill-force flex-gap-12 ">
                    <mat-form-field class="flex flex-fill">
                        <mat-label>Begründung Projektende</mat-label>
                        <input matInput 
                            [required]="budgetService.antrag().endeChanged" 
                            [readonly]="!budgetService.antrag().endeChanged" 
                            [ngClass]="!budgetService.antrag().endeChanged ? 'form-field-readonly' : ''" 
                            placeholder="Begründung zur Veränderung des Projektendes" 
                            [(ngModel)]="budgetService.antrag().endeBegruendung" 
                            (ngModelChange)="budgetService.DataStateChange()" 
                            name="endebegruendung" maxlength="500">
                    </mat-form-field>
                </div>
            </div>   
            <div *ngIf="!budgetService.isBauControlling()" class="flex flex-row flex-stretch-self flex-gap-120">
                <div class="flex flex-col flex-fill">
                    <mat-form-field class="form-field-readonly">
                        <mat-label>Kostenstelle</mat-label>
                        <input matInput [(ngModel)]="budgetService.antrag().kostenstelle" [readonly]="true" name="kostenstelle">
                    </mat-form-field>
                </div>  
                <div class="flex flex-col flex-fill">
                    <mat-form-field class="form-field-readonly">
                        <mat-label>Kostengruppe</mat-label>
                        <input matInput [(ngModel)]="budgetService.antrag().kostengruppe" [readonly]="true" name="kostengruppe">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex flex-row flex-fit flex-stretch-self" [ngClass]="budgetService.isBauControlling() ? 'flex-gap-48' : 'flex-gap-120'">
                <mat-form-field class="flex-fill form-field-remove-hint">
                    <mat-label>Antragsteller</mat-label>
                    <input matInput readonly class="form-field-readonly" placeholder="Antragsteller"
                        [(ngModel)]="budgetService.antrag().antragsteller" name="antragsteller">
                </mat-form-field>
                <mat-form-field class="flex-fill form-field-remove-hint">
                    <mat-label>Antragsdatum</mat-label>
                    <input matInput readonly class="form-field-readonly" [matDatepicker]="picker"
                        placeholder="Antragsdatum" [(ngModel)]="budgetService.antrag().antragsdatum" name="antragsdatum">
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
        </app-element-panel>
        <app-element-panel *ngIf="budgetService.isBauControlling()" pageTitle="Lageplan">
            <div class="flex flex-fill flex-col flex-stretch-self">
                <div class="flex flex-row flex-fit flex-gap-48">
                    <mat-form-field class="flex-fill">
                        <mat-label>Gesamtfläche (m²)</mat-label>
                        <input matInput [readonly]="!budgetService.allowEdit()" type="number" required
                            [(ngModel)]="budgetService.antrag().gesamtflaeche"
                            (ngModelChange)="budgetService.GesamtflaecheChange($event)" name="gesamtflaeche" step="1" pattern="^[0-9]+$" onlyNumbers>
                        <button [disabled]="!budgetService.allowEdit()" type="button" matTooltip="Bestätigen"
                            [ngClass]="{'color-warn': !budgetService.antrag().gesamtflaecheValidated}" matSuffix mat-icon-button
                            (click)="budgetService.GesamtflaecheButtonClick()">
                            <mat-icon>{{budgetService.antrag().gesamtflaecheValidated ? 'check_circle' : 'error'}}</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-form-field class="flex-fill">
                        <mat-label>Sondierfläche (m²)</mat-label>
                        <input matInput [readonly]="!budgetService.allowEdit()" type="number" [(ngModel)]="budgetService.antrag().sonderflaeche"
                            (ngModelChange)="budgetService.DataStateChange()"
                            name="sonderflaeche" step="1" pattern="^[0-9]+$" onlyNumbers >
                        <button [disabled]="!budgetService.allowEdit()" type="button" matTooltip="Bestätigen"
                            [ngClass]="{'color-warn': !budgetService.antrag().sonderflaecheValidated}" matSuffix mat-icon-button
                            (click)="budgetService.SondierflaecheButtonClick()">
                            <mat-icon>{{budgetService.antrag().sonderflaecheValidated ? 'check_circle' : 'error'}}</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
                <div class="flex flex-row flex-fit flex-gap-48">
                    <mat-form-field class="flex-fill">
                        <mat-label>Länge (m)</mat-label>
                        <input matInput [readonly]="!budgetService.allowEdit()" type="number" required [(ngModel)]="budgetService.antrag().laenge"
                           (ngModelChange)="budgetService.LaengeChange($event)" name="laenge" step="1" pattern="^[0-9]+$" onlyNumbers>
                    </mat-form-field>
                    <mat-form-field class="flex-fill">
                        <mat-label>Breite (m)</mat-label>
                        <input matInput [readonly]="!budgetService.allowEdit()" type="number" required [(ngModel)]="budgetService.antrag().breite"
                            (ngModelChange)="budgetService.DataStateChange()" name="breite" step="1" pattern="^[0-9]+$" onlyNumbers>
                    </mat-form-field>
                </div>
                <div class="flex flex-row flex-fit flex-gap-48">
                    <mat-form-field class="flex-fill">
                        <mat-label>Lageplan (Bild- oder PDF-Datei)</mat-label>
                        <input matInput readonly [(ngModel)]="budgetService.antrag().lageplanDateiname" name="lageplandateiname" maxlength="255">
                        <input [readonly]="!budgetService.allowEdit()" type="file" accept="image/*,application/pdf"
                            class="file-input" #fileUpload (change)="budgetService.UploadFileButtonClick($event)">
                        @if (budgetService.antrag().lageplanDateiname == "") {
                        <button [disabled]="!budgetService.allowEdit()" type="button" matSuffix mat-icon-button
                            (click)="fileUpload.click()">
                            <mat-icon>backup</mat-icon>
                        </button>
                        } @else {
                        <button [disabled]="!budgetService.allowEdit()" type="button" matSuffix mat-icon-button
                            (click)="budgetService.DeleteFileButtonClick()">
                            <mat-icon>cancel</mat-icon>
                        </button>
                        }
                    </mat-form-field>
                    <mat-form-field class="flex-fill">
                        <mat-label>Datum des Lageplans</mat-label>
                        <input matInput readonly class="form-field-readonly" [matDatepicker]="pickerlageplan"
                            [(ngModel)]="budgetService.antrag().lageplanDatum" name="lageplandatum">
                        <mat-datepicker-toggle disabled="true" matIconSuffix
                            [for]="pickerlageplan"></mat-datepicker-toggle>
                        <mat-datepicker #pickerlageplan></mat-datepicker>
                    </mat-form-field>
                </div>
                <mat-form-field class="flex-fill form-field-remove-hint">
                    <mat-label>Lageplan</mat-label>
                    @if (budgetService.antrag().lageplanDateiname =="") {
                    <input matInput readonly placeholder="Vorschau (Bild- oder PDF-Datei)" name="lageplan">
                    } @else {
                    @if (budgetService.antragLageplanExtension() == 'pdf') {
                    <input matInput readonly placeholder="Vorschau" name="lageplan" style="display: none;">
                         <div  (dblclick)="onLageplanPdfClick()">
                                <pdf-viewer class="pdf-fit"
									[src]="budgetService.antragLageplanUrl()"
								 	[render-text]="true"
                                 	[original-size]="false">
								</pdf-viewer>
                         </div>
                    } @else {
                    <input matInput readonly placeholder="Vorschau" name="lageplan" style="display: none;">
                    <img matInput class="image-fit" [src]="budgetService.antragLageplanUrl()" priority>
                    }
                    }
                </mat-form-field>
            </div>
        </app-element-panel>
    </div>
</app-page-panel>